import { Tab } from "@circle-react-uikit/TabV2";
import type { TabType } from "./constants";
import { useTabWithFilters } from "./hooks/useTabWithFilters";

export interface TabWithFiltersProps {
  activeFilterTab: string;
  resetAllChargesToFirstPage: () => void;
  setActiveFilterTab: (tab: TabType) => void;
  setSearchKey: (key: string) => void;
}

export const TabWithFilters = ({
  setActiveFilterTab,
  activeFilterTab,
  setSearchKey,
  resetAllChargesToFirstPage,
}: TabWithFiltersProps) => {
  const { tabOptions, changeTabAndResetForm } = useTabWithFilters({
    setActiveFilterTab,
    setSearchKey,
    resetAllChargesToFirstPage,
  });

  const selectedTabIndex = tabOptions.findIndex(
    tab => tab.value === activeFilterTab,
  );

  return (
    <Tab.Group selectedIndex={selectedTabIndex}>
      <Tab.ListWrapper>
        <Tab.List>
          {tabOptions.map(tab => {
            const keyValue = String(tab.value);
            return (
              <Tab
                key={keyValue}
                onClick={() => changeTabAndResetForm(tab.value)}
              >
                {tab.label}
                <Tab.Counter>{tab.badge.value}</Tab.Counter>
              </Tab>
            );
          })}
        </Tab.List>
      </Tab.ListWrapper>
    </Tab.Group>
  );
};
